// material ui
import { styled } from '@mui/material';

// relative
import { CustomLink } from './CustomLink';

const StyledCustomLink = styled(CustomLink)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    color: theme.palette.text.primary,
  },
  '&:visited': {
    color: theme.palette.text.primary,
  },
  '& *': {
    color: 'inherit',
  },
}));

export default StyledCustomLink;
